import React from "react";
import TBBImage from "utils/TBBImage";

const FullWidthImage = ({blok}) => {
    return (
        <div className="my-8">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <TBBImage image={blok.image}/>
            </div>
        </div>
    );
};

export default FullWidthImage;